import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Section from "./components/Section";
import Timeline from "./components/Timeline";
//import Rsvp from "./components/Rsvp";
import Footer from "./components/Footer";
import fancyLine from "./assets/fancy_line.png";
import fancyLineRight from "./assets/fancy_line_right.png";
import fancyLineLeft from "./assets/fancy_line_left.png";
import photosDriveLink from "./assets/photos_drive_link.png";

// const scrollToId = (id) => () =>
//   document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

export default function App() {
  const program = [
    { time: "14:00", name: "Szállás elfoglalása" },
    { time: "14:30", name: "Vendégvárás" },
    { time: "15:50", name: "Egyházi szertartás" },
    { time: "17:20", name: "Polgári szertartás" },
    { time: "19:15", name: "Vacsora" },
    { time: "23:00", name: "Menyasszonytánc" },
    { time: "23:30", name: "Torta" },
    { time: "00:00", name: "Éjféli vacsora" },
    { time: "", name: "... majd hajnalig tartó mulatság!" },
    { time: "08:00", name: "Reggeli (12:00 óráig)" },
    { time: "11:00", name: "Szoba elhagyása" },
    { time: "", name: "... egész napos wellness és sport lehetőség!" },
    // { time: "14:00 - 14:30", name: "Szállás elfoglalása" },
    // { time: "14:30 - 15:20", name: "Vendégvárás" },
    // { time: "16:00 - 16:45", name: "Egyházi szertartás" },
    // { time: "17:30 - 18:15", name: "Polgári szertartás" },
    // { time: "19:15", name: "Vacsora" },
    // { time: "23:00", name: "Menyasszonytánc" },
    // { time: "23:30", name: "Torta" },
    // { time: "1:00", name: "Éjféli vacsora" },
    // { time: "1:00 - 4:00", name: "Hajnalig tartó mulatság!" },
    // { time: "08:00", name: "Reggeli" },
    // { time: "08:00 - 10:00", name: "Wellness" },
    // { time: "11:00", name: "Szállás elhagyása" },
  ];

  return (
    <>
      <div className="background" />
      <div className="main-content">
        <Navbar />

        {/* HERO */}
        <header className="heroWrap">
          <div className="container">
            <div className="heroCard">
              <div className="heroContent">
                <div className="heroTitle">
                  <img className="fancyFull mobile-flip" src={fancyLine} alt="" aria-hidden="true"/>
                  <div className="heroTitleRow">
                    <img className="fancySide fancyLeft" src={fancyLineLeft} alt="" aria-hidden="true" />
                    <span className="heroWelcome">Üdvözlünk!</span>
                    <img className="fancySide fancyRight" src={fancyLineRight} alt="" aria-hidden="true" />
                  </div>
                </div>
                <p style={{ marginTop: 10, color: "rgba(246,242,233,0.86)" }}>
                  Sok szeretettel várunk benneteket, hogy együtt ünnepelhessünk életünk egyik legszebb napján!
                </p>
                <p style={{ marginTop: 0, color: "rgba(246,242,233,0.86)" }}>
                  A meghívóban szereplő napon találkozunk Veletek leghamarabb 14:00-kor a Geréby Kúrián. Minden egyéb információt megtaláltok a itt, de ha bármi kérdésetek lenne, keressetek minket bizalommal! Alig várjuk, hogy együtt ünnepelhessünk Veletek!
                </p>
                <a href="https://drive.google.com/drive/folders/10vq_CTJqzOdOeH-vtQHYV-UTffdM7uCz" target="_blank" rel="noopener noreferrer">
                  <img className="fancyFull" src={photosDriveLink} alt="" aria-hidden="true" style={{ maxWidth: "280px", cursor: "pointer" }} />
                </a>
                <p style={{ marginTop: 0, color: "rgba(246,242,233,0.86)" }}>
                  Szívesen látjuk ezt a napot a Ti szemszögetekből is! Ha készítetek fotókat, videókat, kérjük, osszátok meg velünk itt, hogy a nagy nap emlékei közé bekerülhessenek a Ti pillanataitok is! Csak olvassátok be ezt a QR kódot, vagy kattintsatok a képre, és máris feltölthetitek a képeket, videókat!
                </p>
                <img className="fancyFull" src={fancyLine} alt="" aria-hidden="true" />
              </div>
            </div>
          </div>
        </header>

        <Section id="helyszin" kicker="Helyszínek" title="Hogyan juttok el?">
          <div className="grid2">
            {/* <div className="mapMock">
              <div>
                <div className="gold" style={{letterSpacing: 2, textTransform: "uppercase" }}>
                  Térkép
                </div>
                <p className="small">
                  Google Maps(templom + kúria).
                </p>
                <div className="btnRow" style={{ justifyContent: "center" }}>
                  <button className="btn">Kúria térkép</button>
                  <button className="btn">Templom térkép</button>
                </div>
              </div>
            </div> */}

            <div className="card">
              <div className="small">
                <div className="gold" style={{ letterSpacing: 2, textTransform: "uppercase", textAlign: "center" }}>Geréby Kúria</div>
                <div style={{ textAlign: "center", letterSpacing: 2, fontWeight: 600, marginBottom: 10 }}>6050 Lajosmizse, Alsólajos tanya 224.</div>

                <div className="mapWrap">
                  <iframe className="mapFrame"
                    title="Geréby Kúria térkép"
                    src="https://www.google.com/maps?q=Geréby+Kúria,+6050+Lajosmizse,+Alsólajos+tanya+224.&output=embed&t=k"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="small">
                <div className="gold" style={{ letterSpacing: 2, textTransform: "uppercase", textAlign: "center" }}>Ménteleki Református Templom</div>
                <div style={{ textAlign: "center", letterSpacing: 2, fontWeight: 600, marginBottom: 10 }}>6008 Kecskemét, Kecskeméti út 9.</div>

                <div className="mapWrap">
                  <iframe className="mapFrame"
                    title="Ménteleki Református Templom térkép"
                    src="https://www.google.com/maps?q=Ménteleki+Református+Templom,+6008+Kecskemét,+Kecskeméti+út+9.&output=embed&t=k"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </Section>

        <Section
          id="program"
          kicker="Program"
          title="A nagy nap menete"
        >
          <Timeline items={program} />
        </Section>

        <Section id="menu" kicker="Menü" title="Étlap és itallap">
          <div className="card" style={{ padding: 22 }}>
            <div className="divider" />
            <div className="menuGrid">
              {/* Ételek oszlop */}
              <div className="small menuFood">
                <div className="gold">Leves</div>
                <div>Újházi tyúkhúsleves (tálban felszolgálva)</div>
                <div className="gold" style={{ marginTop: 25 }}>Főételek</div>
                <div>Vörösboros marhapörkölt</div>
                <div>Csirkemellcsíkok sokmagvas bundában</div>
                <div>Ropogós sült sertéscsülök</div>
                <div>Kolozsvári göngyölt sertéskaraj zöldborsmártással</div>
                <div>Rántott gomba</div>
                <div className="gold" style={{ marginTop: 25 }}>Köret</div>
                <div>Galuska</div>
                <div>Sós burgonya</div>
                <div>Párolt rizs</div>
                <div>Petrezselymes burgonya</div>
                <div>Párolt káposzta</div>
                <div>Grillen sült zöldség kavalkád</div>
                <div>Tartármártás</div>
                <div>Saláta büfé</div>
                <div className="gold" style={{ marginTop: 25 }}>Torta</div>
                <div>Csokoládés-meggyes torta</div>
                <div>Málnás-pisztácia torta</div>
                <div>Ferrero Rocher torta</div>
                <div>Mangós-mascarponés torta (glutén*, laktóz, cukor mentes)</div>
                <div className="gold" style={{ marginTop: 25 }}>Sütemények</div>
                <div>Linzer</div>
                <div>Kókusz golyó</div>
                <div>Mézes krémes</div>
                <div>Zserbó</div>
                <div>Citromos áfonyás tarte</div>
                <div>Csokis málnás tarte</div>
                <div className="gold" style={{ marginTop: 25 }}>Éjféli vacsora</div>
                <div>Töltött káposzta</div>
              </div>
              {/* Italok oszlop */}
              <div className="small menuDrinks">
                <div className="gold">Alkoholos italok</div>
                <div>Házi diólikőr</div>
                <div>Barack- és ágyas szilvapálinka</div>
                <div>Vodka</div>
                <div>Gin</div>
                <div>Tequila</div>
                <div>Bacardi</div>
                <div>Whiskyk</div>
                <div>Unicum</div>
                <div>Jägermeister</div>
                <div>Krémlikőr</div>
                <div>Sör</div>
                <div>Ház borai (Frittmann pincészet)</div>
              <div className="gold" style={{ marginTop: 25 }}>Koktélok</div>
                <div>Alkoholos:</div>
                <div style={{ marginLeft: 22 }}>
                  <div>Hugo</div>
                  <div>Tequila sunrise</div>
                  <div>Margarita</div>
                  <div>Gin tonic</div>
                  <div>Whiskey Cola</div>
                  <div>Long Island Iced Tea</div>
                  <div>Cuba libre</div>
                  <div>Cosmopolitan</div>
                  <div>Sex on the beach</div>
                  <div>Piña Colada</div>
                  <div>Mojito</div>
                  <div>Aperol Spritz</div>
                </div>
                <div>Alkoholmentes:</div>
                <div style={{ marginLeft: 22 }}>
                  <div>Virgin Mojito</div>
                  <div>Cinderella</div>
                  <div>Virgin Piña Colada</div>
                  <div>Limonádé</div>
                  <div>Apple Spritz</div>
                </div>
              <div className="gold" style={{ marginTop: 25 }}>Alkoholmentes italok</div>
                <div>Kvász</div>
                <div>Ice Tea</div>
                <div>Almaital</div>
                <div>Rostos őszibarack</div>
                <div>Narancslé</div>
                <div>Ananászlé</div>
                <div>Coca-Cola</div>
                <div>Cola zero</div>
                <div>Fanta</div>
                <div>Sprite</div>
                <div>Tonic</div>
                <div>Gyömbér</div>
                <div>Ásványvíz: szénsavas, szénsavmentes</div>
                <div className="gold" style={{ marginTop: 25 }}>Kávé</div>
                <div>Espresso</div>
                <div>Macchiato</div>
                <div>Cappuccino</div>
                <div>Latte</div>
                <div>Latte Macchiatto</div>
              </div>
            </div>
          </div>
        </Section>

        <Section id="rsvp" kicker="Visszajelzés" title="Velünk ünnepeltek?">
          <div className="card" style={{ padding: 22}}>
            <p className="small" style={{ marginTop: 0, marginBottom: 0}}>
              Kérjük, legkésőbb <span className="gold">május 31-ig</span> jelezzétek vissza, hogy részt tudtok-e venni az esküvőnkön, és ha igen, hány fővel érkeztek. Amennyiben gyermekekkel jöttök, kérjük, jelezzétek a gyermekek életkorát is.
            </p>
            <p className="small" style={{ marginTop: 0, marginBottom: 0}}>
              Kérjük továbbá, hogy jelezzétek, ha van bármilyen ételallergiátok, speciális étrendetek, illetve ha szállásra van szükségetek.
            </p>
            {/* TODO */}
            {/* <Rsvp /> */}  
            <p className="small" style={{ marginBottom: 0, marginTop: 14, opacity: 0.85 }}>
              Kapcsolat: 
            </p>
            <p className="small" style={{ marginLeft: 20, marginTop: 0, marginBottom: 0}}>
              E-mail: <span className="gold">elizesgergo@gmail.com</span>
            </p>
            <p className="small" style={{ marginLeft: 20, marginTop: 0, marginBottom: 0}}>
              Gergő mobil: <span className="gold">+36 30 825 1753</span>
            </p>
            <p className="small" style={{ marginLeft: 20, marginTop: 0, marginBottom: 0}}>
              Elíz mobil: <span className="gold">+36 70 261 3165</span>
            </p>
          </div>
        </Section>

        <Section id="faq" kicker="Tudnivalók" title="Amit még tudni érdemes">
          <div className="card" style={{ padding: 22 }}>
            <ul style={{ paddingLeft: 30, marginTop: 0, marginBottom: 0 }}>
              <li className="small" style={{ marginBottom: 6 }}>A szobákat 11:00 óráig kell elhagyni. De:</li>
              <li className="small" style={{ marginBottom: 6, marginLeft: 18 }}>Itt tartózkodó vendégeinknek <strong>reggeli</strong> az esküvő másnapján biztosított 12:00 óráig.</li>
              <li className="small" style={{ marginBottom: 6, marginLeft: 18 }}>Itt tartózkodó vendégeinknek <strong>wellnes használat</strong> az esküvő másnapján ingyenes. (pezsgőfürdő, finn szauna, infraszauna, nyitott úszómedence, sport- és teniszpályák, játszópark, értékmegőrző)</li>
              <li className="small" style={{ marginBottom: 6 }}>Parkolás a helyszínen ingyenesen biztosított.</li>
              <li className="small" style={{ marginBottom: 6 }}>Kisgyermekeket is szívesen látjuk. Jelezzetek és annak megfelelően készülünk!</li>
              <li className="small" style={{ marginBottom: 6 }}>Szállás biztosított a készlet erejéig, erre vonatkozó igényt kérjük jelezzétek.</li>
              <li className="small" style={{ marginBottom: 6 }}>Igény esetén a helyszínek közti transzfer szervezésében is segítünk.</li>
            </ul>
            <div className="pdfBlock">
                <a
                  className="pdfCard"
                  href="https://www.gereby.hu/images/pdf/gerebykuria_teruletterkep.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="pdfCardTitle">Geréby Kúria területtérkép</div>
                  <div className="pdfCardSub">Megnyitás PDF-ben</div>
                </a>
              <iframe className="pdfFrame"
                src="https://www.gereby.hu/images/pdf/gerebykuria_teruletterkep.pdf"
                title="Geréby Kúria terület térkép"
                allowFullScreen
              ></iframe>
            </div>
            {/* ...existing code... */}
          </div>
        </Section>

        <Footer />
      </div>
    </>
  );
}
